module.exports = __webpack_public_path__ + "static/media/S3N13-5.244651de.svg";